var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"connection-lost"},[_c('h1',{staticClass:"text-center text-white"},[_c('i',{staticClass:"fas fa-wifi"}),_c('br'),_c('small',{staticClass:"small-text"},[_vm._v(_vm._s(_vm.$t('alerts.connectionFail.message')))])]),_c('div',{staticClass:"login-logo"},[_c('img',{attrs:{"src":_vm.logo,"alt":"logo"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }